import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {OmdbModel, Search} from 'src/app/model/omdb-tmdb-models/omdb.model';
import {CustomHttpUrlEncodingCodec} from '../../../main/encoder';

@Injectable({
  providedIn: 'root',
})
export class ThemoviedbService {
  theMovieDb: string = 'https://ap.themoviedb.org/3/movie/';
  api_key: string = '?api_key=c73003e552acb6d9a37e67ef685790e9';
  append_to_response_credit: string = '&append_to_response=credits';

  constructor(private http: HttpClient) {}

  getMovieByTheMovieDb(contentName: string): Observable<any> {
    return this.http.get<any>(this.theMovieDb + contentName + this.api_key + this.append_to_response_credit);
  }

  getMetaDataByOriginalTitle(searchQuery?: string, season?: number, episode?: number, type?: string, page?: number): Observable<OmdbModel> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (season) queryParams = queryParams.set('season', <any>season);
    if (episode) queryParams = queryParams.set('episode', <any>episode);
    type.toLowerCase();
    if (type == 'movie') {
      queryParams = queryParams.set('type', <any>type);
    } else {
      queryParams = queryParams.set('type', <any>'series');
    }
    if (page) {
      queryParams = queryParams.set('page', <any>page);
    }

    return this.http.get<OmdbModel>('https://www.omdbapi.com/?apikey=d8ec0959&s=' + searchQuery, {params: queryParams});
  }

  getMetadataByImdbId(searchQuery?: string, season?: number, episode?: number, type?: string): Observable<Search> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (season) queryParams = queryParams.set('season', <any>season);
    if (episode) queryParams = queryParams.set('episode', <any>episode);
    type.toLowerCase();
    if (type == 'movie') {
      queryParams = queryParams.set('type', <any>type);
    } else {
      queryParams = queryParams.set('type', <any>'series');
    }
    return this.http.get<Search>('https://www.omdbapi.com/?apikey=d8ec0959&i=' + searchQuery, {params: queryParams});
  }

  getImdbDetailData(imdbID: string, season?: number, episode?: number): Observable<any> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (season) queryParams = queryParams.set('Season', <any>season);
    if (episode) queryParams = queryParams.set('Episode', <any>episode);

    return this.http.get<any>('https://www.omdbapi.com/?apikey=d8ec0959&i=' + imdbID, {params: queryParams});
  }
}
